<template>
  <path
    d="M14.5 18.0002H8C6.9 18.0002 6 17.1002 6 16.0002V9.50018C6 8.67018 6.67 8.00018 7.5 8.00018C8.33 8.00018 9 8.67018 9 9.50018V12.7702L14.95 7.00018C15.52 6.45018 16.43 6.46018 16.99 7.02018C17.55 7.58018 17.55 8.49018 17 9.06018L11.15 15.0002H14.5C15.33 15.0002 16 15.6702 16 16.5002C16 17.3302 15.33 18.0002 14.5 18.0002Z"
  />
</template>
